// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__14b6o","header":"MergedInvoice_header__3KSkm"};